import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LookupTableModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { LookupTableAction } from '../actions';
import { LookupTableReducer } from '../reducers';
import { LookupTableSelector } from '../selectors';

@Injectable()
export class LookupTableFacade {
  selectedItem$ = this._store.select(LookupTableSelector.selectLookupTable);
  constructor(private _store: Store<LookupTableReducer.LookupTableState>) {}

  /**
   * Get @LookupTableModel by id
   */
  getById(id: number): Observable<LookupTableModel | null> {
    this._store.dispatch(LookupTableAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<LookupTableModel | null>;
  }
}
